"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Table_1 = __importDefault(require("@mui/material/Table"));
var TableCell_1 = require("@mui/material/TableCell");
var StyledSubTable = (0, styles_1.styled)(Table_1.default)(function () {
    var _a;
    return (_a = {},
        _a[".".concat(TableCell_1.tableCellClasses.root)] = {
            fontSize: '12px',
            color: 'rgba(0,0,0, 0.87)'
        },
        _a);
});
exports.default = StyledSubTable;
